import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { MessageService } from '../../services/message.service';
import { Subscription } from 'rxjs';
import { PartnerService } from 'src/app/services/partner.service';
import { flat, unflatten } from 'flat';

@Component({
    selector: 'app-sso-login',
    templateUrl: './sso-login.component.html',
    styleUrls: ['./sso-login.component.scss'],
    host: { 'class': 'sso-login main-screen' },
    standalone: false
})
export class SSOLoginComponent implements OnInit {
    registerForm: UntypedFormGroup;
    submitted = false;
    emailFocus = false;
    passwordFocus = false;
    serverError: any = '';
    token;
    emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
    form: UntypedFormGroup;
    message: any;
    subscription: Subscription;

    constructor(
        private authS: AuthService,
        private fb: UntypedFormBuilder,
        private router: Router,
        private actRoute: ActivatedRoute,
        private userSer: UserService,
        private partnerSer: PartnerService,
        private msg: MessageService
    ) {
        if (this.authS.isLoggedIn() && false ) {
            this.router.navigate(['/dashboard']);
        }

        this.subscription = this.msg.getMessage().subscribe(message => { this.message = message; });
    }

    ngOnInit() {
        this.registerForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]],
            check: ''
        });

        this.actRoute.queryParams.subscribe( params => {
            if (params['sso_error']) {
                this.serverError = this.authS.ssoErrorMessage(params['sso_error']);
                return;
            }

            if (params['ticket']) {
                this.authS.completeSso(params['ticket']).subscribe((data: any) => {
                    if (data && data.status && data.csrf_access) {
                        this.authS.persistSession(data);
                        this.router.navigate(['/dashboard']);
                    } else {
                        this.router.navigate(['/login'], { queryParams: { sso_error: data && data.code ? data.code : 'token_expired' } });
                    }
                }, (err) => {
                    const code = err && err.error && (err.error.code || err.error.error) ? (err.error.code || err.error.error) : 'token_expired';
                    this.router.navigate(['/login'], { queryParams: { sso_error: code } });
                });
                return;
            }

            if (!params['payload']) {
                this.serverError = 'Sign-in did not complete.';
                return;
            }

            let unfl;
            let data;
            try {
                unfl = JSON.parse(params['payload']);
                data = unflatten( unfl );
            } catch (e) {
                this.serverError = 'Sign-in did not complete.';
                return;
            }
            // The payload carries bearer tokens; keep them out of the address bar and history.
            window.history.replaceState(null, '', window.location.pathname);

            if (unfl.status) {
                this.authS.sessionFromToken(data.access_token).subscribe({
                    next: (session: any) => { this.authS.persistSession(session); this.router.navigate(['/dashboard']); },
                    error: () => { this.serverError = 'Your sign-in link is invalid or has expired. Please sign in again.'; }
                });
            } else {
                this.serverError = params['error'] || this.authS.ssoErrorMessage('unknown_user');
            }
        });
    }

    // convenience getter for easy access to form fields
    get f() { return this.registerForm.controls; }

    onSubmit() {

        // stop here if form is invalid
        if (this.registerForm.invalid) {
            this.submitted = true;
            return;
        } else {
            this.authS.getLogin(this.registerForm.value.email, this.registerForm.value.password).subscribe((data: any) => {
                if (data.status) {
                    localStorage.clear();
                    this.authS.storeCsrf(data);
                    localStorage.setItem('ClientID', data.UserData.ClientID);
                    localStorage.setItem('UserData', JSON.stringify(data.UserData));
                    localStorage.setItem('info', JSON.stringify(data));

                    localStorage.setItem('notSubscribed', 'Your subscription does not include access to this feature. ' +
                          'If you are interested in learning more, please email info@myhrcounsel.com or call (612) 339-1421');
                    localStorage.setItem('showErisa', 'yes');
                    if (data.UserData.client && data.UserData.client.PartnerID) {
                        this.partnerSer.getPartner(data.UserData.client.PartnerID).subscribe((partnerData: any) => {
                            if (partnerData.ServiceSolicitation !== null &&
                                partnerData.ServiceSolicitation.trim().length > 0) {
                                  localStorage.setItem('notSubscribed', partnerData.ServiceSolicitation);
                            }
                            if (partnerData.ErisaCenter != null) {
                                localStorage.setItem('showErisa', (partnerData.ErisaCenter === 1 ? 'yes' : 'no'));
                            }
                            if (partnerData.ToolsList != null) {
                                localStorage.setItem('toolsList', partnerData.ToolsList );
                            } else {
                                localStorage.removeItem( 'toolsList' );
                            }
                        });
                    }


                    this.router.navigate(['/dashboard']);
                } else {
                    this.serverError = data.error;
                }
            });
        }

    }

  autofocus(text) {
      if (text === 'email') {
        this.emailFocus = true;
        this.passwordFocus = false;
      } else {
        this.passwordFocus = true;
        this.emailFocus = false;
      }
  }
}

